module.exports = ".title-alignment{flex:auto;padding-top:10px}"